import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import http from '../Api/http';
import { GetDepartments, GetDesignations } from '../Api/Api';
import { selectActiveEntityId, ALL_ENTITY_ID } from '../redux/slices/orgSlice';

const pick = (settled, key, activeEntityId) => {
    const body = settled.status === 'fulfilled' ? settled.value?.data : null;
    if (!body || body.error) return { rows: [], names: [] };
    const all = Array.isArray(body?.data?.[key]) ? body.data[key] : [];
    const rows = (activeEntityId === ALL_ENTITY_ID
        ? all
        : all.filter((r) => r.entityId == null || String(r.entityId) === String(activeEntityId))
    ).filter((r) => r.isActive !== false && String(r.status || 'Active').toLowerCase() !== 'inactive');
    const names = [...new Set(rows.map((r) => (r.name || '').trim()).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b));
    return { rows, names };
};

export default function useOrgOptions() {
    const activeEntityId = useSelector(selectActiveEntityId);
    const [state, setState] = useState({
        departments: [], designations: [], departmentNames: [], designationNames: [], loading: true,
    });

    const load = useCallback(async () => {
        setState((s) => ({ ...s, loading: true }));
        const [deptRes, desigRes] = await Promise.allSettled([
            http.get(GetDepartments),
            http.get(GetDesignations),
        ]);
        const dep = pick(deptRes, 'departments', activeEntityId);
        const des = pick(desigRes, 'designations', activeEntityId);
        setState({
            departments: dep.rows,
            designations: des.rows,
            departmentNames: dep.names,
            designationNames: des.names,
            loading: false,
        });
    }, [activeEntityId]);

    useEffect(() => { load(); }, [load]);

    return { ...state, reload: load };
}
